import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotEvents from "./components/HotEvents";
import Collections from "./components/Collections";
import DeepDives from "./components/DeepDives";
import About from "./components/About";
import FAQ from "./components/FAQ";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

const SITE_JSON_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://mvjc.cn/#org",
      name: "今日瓜报",
      url: "https://mvjc.cn/",
      logo: "https://mvjc.cn/logo.png",
      description:
        "专注吃瓜事件盘点与合集时间线的内容站，把娱乐圈与行业的吃瓜事件按事件顺序整理成完整脉络。",
    },
    {
      "@type": "WebSite",
      "@id": "https://mvjc.cn/#website",
      url: "https://mvjc.cn/",
      name: "今日瓜报",
      inLanguage: "zh-CN",
      publisher: { "@id": "https://mvjc.cn/#org" },
    },
    {
      "@type": "WebPage",
      "@id": "https://mvjc.cn/#webpage",
      url: "https://mvjc.cn/",
      name: "今日吃瓜事件盘点与合集时间线 - 今日瓜报",
      isPartOf: { "@id": "https://mvjc.cn/#website" },
      about: "今日吃瓜事件盘点与合集",
      inLanguage: "zh-CN",
    },
  ],
};

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(SITE_JSON_LD) }}
      />
      <Navbar />
      <main>
        <Hero />
        <HotEvents />
        <Collections />
        <DeepDives />
        <About />
        <FAQ />
        <Subscribe />
      </main>
      <Footer />

      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="回到顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition-all hover:bg-primary-600 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-6 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-xl" />
      </button>
    </>
  );
}